class QuickAddProduct {
    constructor() {
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    addSelectedVariant(variantId, productId, sectionId = "noSectionId") {
        const formData = {
            items: [{
                id: variantId,
                quantity: 1,
                properties: { _quick_add: true }
            }],
            sections: "plano-c-cart-drawer,cart-icon-bubble"
        };
        if(sectionId != "noSectionId") {
          this.showLoadingSpinner(productId, sectionId);
        }
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            if (!data.status) {
                if (this.cart) {
                    if (data.items && data.items.length > 0) {
                        this.handleCartUpdated(data.items, data.sections);
                      if(sectionId != "noSectionId") {
                        this.disableLoadingSpinner(productId, sectionId);
                      }
                    }
                } else {
                    window.location = window.routes.cart_url;
                }
            }
        })
        .catch(error => {
            console.error('Error:', error);
            if(sectionId != "noSectionId") {
              this.disableLoadingSpinner(productId, sectionId);
            }
        });
    }

    showLoadingSpinner(productId, sectionId) {
        const labels = document.getElementsByClassName('plano-c-label-'+productId+'-'+sectionId);
        for (let i = 0; i < labels.length; i++) {
            labels[i].classList.add('hidden');
        }
        document.getElementsByClassName('loading-for-'+productId)[0].classList.remove('hidden');
    }

    disableLoadingSpinner(productId, sectionId) {
        const labels = document.getElementsByClassName('plano-c-label-'+productId+'-'+sectionId);
        for (let i = 0; i < labels.length; i++) {
            labels[i].classList.remove('hidden');
        }
        document.getElementsByClassName('loading-for-'+productId)[0].classList.add('hidden');
    }
    
    handleCartUpdated(items, sections) {
        if (this.cart) {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.setActiveElement(document.activeElement);
            items.forEach(item => {
                this.cart.renderContents({
                    ...item,
                    sections: sections
                });
            });
            document.getElementById("CartDrawer-Form").style.display = "block";
        }
    }
}

const quickAddProduct = new QuickAddProduct();